/** request id key */
export const REQUEST_ID_KEY = 'X-Request-Id';

/** the backend error code key */
export const BACKEND_ERROR_CODE = 'BACKEND_ERROR';

export const ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
